import { phonePlaceholders, phoneCountries } from '../common/constants/phoneInputConstants';
/**
 * Get phone number placeholder by language code from i18n
 * @param {string} language - i18n.language code
 * @returns {string} phone number placeholder
 * @example
 * getPhoneNumberPlaceholder('en') // +1 (000) 000-0000
 * @see {@link phonePlaceholders} for more information
 */
export function getPhoneNumberPlaceholder(language) {
    return phonePlaceholders[language] || '+1 (000) 000-0000';
}

/**
 * Get phone input country by language code from i18n
 * @param {string} language - i18n.language code
 * @returns {*} phone input country for button flag in ReactPhoneInput2 component
 * @example
 * getPhoneInputCountry('en') // 'us' (United States flag)
 * @see {@link phoneCountries} for more information
 */
export function getPhoneInputCountry(language) {
    return phoneCountries[language] || 'us';
}
